import React from 'react';
import styles from './formulari.module.scss';
// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';

const Boto = BotoComponent as React.ComponentType<{
    text?: string;
    estil?: string;
    tag?: string;
    [key: string]: any;
}>;

type FormulariDadesProps = {
    nom?: string;
    [key: string]: any;
};

export default function FormulariDades(props: FormulariDadesProps) {
    const { nom } = props;
    return (
        <>
            <div className={styles.formulari}>
                <div className={styles.dades}>
                    <span>(*) Camps obligatoris</span>
                </div>
                <form action='https://www.3cat.cat/su/Register' method='post' name={nom} encType='multipart/form-data' id={nom}>
                    <div className={styles.dades}>
                        <div className={styles.formField}>
                            <label htmlFor='ENTITAT' className={styles.required}>
                                Entitat / Empresa*
                            </label>
                            <input type='text' id='ENTITAT' name='ENTITAT' required />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='NOM' className={styles.required}>
                                Nom*
                            </label>
                            <input type='text' id='NOM' name='NOM' required />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='COGNOMS' className={styles.required}>
                                Cognoms*
                            </label>
                            <input type='text' id='COGNOMS' name='COGNOMS' required />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='ADRECA'>Adreça</label>
                            <input type='text' id='ADRECA' name='ADRECA' />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='CODIPOSTAL'>Codi postal*</label>
                            <input type='text' id='CODIPOSTAL' name='CODIPOSTAL' />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='POBLACIO'>Població</label>
                            <input type='text' id='POBLACIO' name='POBLACIO' />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='TELEFON'>Telèfon de contacte</label>
                            <input type='text' id='TELEFON' name='TELEFON' />
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='CORREU'>Correu electrònic*</label>
                            <input type='email' id='CORREU' name='CORREU' />
                            <span className={styles.mesinfoInput}>Per exemple: nom@exemple.com</span>
                        </div>
                        <div className={styles.formField}>
                            <label htmlFor='DATE'>Data de naixement</label>
                            <input type='date' id='DATE' name='DATE' />
                        </div>

                        <div className={styles.formField}>
                            <label htmlFor='IMGID'>Escriu el codi de la imatge</label>
                            <div className={styles.img_captcha}>
                                <img
                                    alt='Imatge del codi captcha'
                                    src={`https://www.3cat.cat/su/shared/image.jsp?imgId=${Math.random()}`}
                                />
                                <input value='IMGID' id='hiImgNumber' name='hiImgNumber' type='hidden' />
                            </div>
                            <input name='IMGID' id='IMGID' type='text' className={styles.camp_captcha} required />
                        </div>
                        <div className={styles.formField}>
                            <input name='tos_checkbox' id='tos_checkbox' type='checkbox' required />
                            <label htmlFor='tos_checkbox'>
                                He llegit i accepto la{' '}
                                <a
                                    href='https://www.3cat.cat/avis-legal/privacitat/fundacio-la-marato/'
                                    className={styles.linkForm}
                                >
                                    política de privacitat*
                                </a>
                            </label>
                        </div>

                        <input name='hiTarget' type='hidden' value='/tv3/marato/dades/ok' />
                        <input name='hiErrTarget' type='hidden' value='/tv3/marato/dades/ko' />

                        <input type='hidden' name='hiRegServiceId' value='MRT_CONTACTFAQ' />
                        <input type='hidden' name='hiServiceId' value='MRT_CONTACTFAQ' />
                        <input type='hidden' name='from' value='no_reply@tv3.cat' />
                        <input type='hidden' name='hiAction' value='254' />

                        <div>
                            <Boto text='Envia' estil='neutral' tag='button' />
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
